import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';
import { useNotification } from '@/context/notification';
import { useDeletePlan } from '@/data/idp/plans';

interface DeletePlanDialogProps {
  id: string;
  onClose: () => void;
}

export const DeletePlanDialog = ({ id, onClose }: DeletePlanDialogProps) => {
  const navigate = useNavigate();
  const { mutate, isPending } = useDeletePlan();
  const { toast } = useNotification();

  const deletePlan = () => {
    mutate(id, {
      onSuccess: () => navigate('/pdi/planos'),
      onError: () => {
        toast({
          content:
            'Não foi possível excluir o plano. Tente novamente mais tarde.',
          type: 'error',
        });
      },
    });
  };

  return (
    <BaseDialog
      title="Tem certeza de que quer excluir este plano?"
      onClose={onClose}
      icon={<Icon name="siren-rounded" />}
      actionsComponent={
        <>
          <Button onClick={onClose}>Voltar</Button>
          <Button variant="contained" onClick={deletePlan} loading={isPending}>
            Excluir plano
          </Button>
        </>
      }
    >
      <Typography>
        Todas as informações e o progresso serão removidos, e essa ação não
        poderá ser desfeita.
      </Typography>
    </BaseDialog>
  );
};
